(function () {
  var DURATION = 300;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function animate(item, body, startHeight, endHeight, opening) {
    item.classList.add('et-lp-ingredients__item--animating');
    body.style.overflow = 'hidden';
    body.style.height = startHeight + 'px';

    /* force reflow so the starting height is applied before transitioning */
    void body.offsetHeight;

    body.style.transition = 'height ' + DURATION + 'ms ease';
    body.style.height = endHeight + 'px';

    function onEnd(event) {
      if (event && event.propertyName !== 'height') return;
      body.removeEventListener('transitionend', onEnd);
      body.style.transition = '';
      body.style.height = '';
      body.style.overflow = '';
      item.classList.remove('et-lp-ingredients__item--animating');
      if (!opening) item.open = false;
    }

    body.addEventListener('transitionend', onEnd);
  }

  function toggle(item, body) {
    if (item.classList.contains('et-lp-ingredients__item--animating')) return;

    if (prefersReducedMotion()) {
      item.open = !item.open;
      return;
    }

    if (item.open) {
      animate(item, body, body.scrollHeight, 0, false);
    } else {
      item.open = true;
      animate(item, body, 0, body.scrollHeight, true);
    }
  }

  function initItem(item) {
    if (item.dataset.etAccordionReady) return;
    item.dataset.etAccordionReady = 'true';

    var summary = item.querySelector('.et-lp-ingredients__head');
    var body = item.querySelector('.et-lp-ingredients__body');
    if (!summary || !body) return;

    summary.addEventListener('click', function (event) {
      event.preventDefault();
      toggle(item, body);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.et-lp-ingredients__item').forEach(initItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
